/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { Box, ImageListItem, Stack } from "@mui/material";
import GalleryContext from "./context";
import GalleryCard from "components/webpage-selector/gallery/gallery-card";
import SelectedBadge from "components/webpage-selector/gallery/buttons/selected-badge";

const SelectGalleryItem = (props) => {
    
    const isSelected = props.isSelected;
    const webpage = props.webpage;
    
    const ctx = useContext(GalleryContext);
    const { setSelectedWebpage } = ctx;
    
    const selectWebpage = (e, webpage) => {
        e.stopPropagation();
        setSelectedWebpage(webpage);
    };
    
    return (
        <>
            <ImageListItem cols={2}>
                <Box sx={{
                    display: "flex", flexDirection: "column", alignItems: "center",
                    width: "100%", paddingRight: "4px", paddingLeft: "4px"
                }}
                >
                    <GalleryCard webpage={webpage} selectWebpage={selectWebpage}>
                        <Stack direction='row' justifyContent='flex-start' sx={{ width: "100%" }}>
                            {/*  to add selection capabilities  */}
                            {isSelected &&
                                <SelectedBadge color='#00685E' />
                            }
                        </Stack>
                    </GalleryCard>
                    {/*<Stack direction='row' justifyContent='flex-end' sx={{ width: '100%'}} >*/}
                    {/*    <EditButton*/}
                    {/*        webpage={webpage}*/}
                    {/*        color='#DFDFDF'*/}
                    {/*        onClick={onEditWebpageClick}*/}
                    {/*    />*/}
                    {/*</Stack>*/}
                </Box>
            </ImageListItem>
        </>
    );
};
export default SelectGalleryItem;
